/* eslint-disable
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import notifications from 'notifications';
import * as util from 'biojs/Util';
import SimpleSlotTemplate from 'assembly/SimpleSlotTemplate';
import * as sequtil from 'molbio/SeqUtil';
import SingleFragmentSlotView from 'assembly/views/SingleFragmentSlotView';
import Enzymes from 'molbio/enzymes/backbone/Enzymes';

class SimpleSlotView extends SingleFragmentSlotView {
  static initClass() {
    this.prototype.template = SimpleSlotTemplate;
  }

  updateSequence(sequence) {
    super.updateSequence(sequence);
    if (this.selection != null) {
      this.listenTo(this.selection, 'change', this.updateToolbar);
    }
    this.updateToolbar();
  }

  toggleActive() {
    this.$el.toggleClass('active', this.model.active());
    this.$('.assembly-slot-options').toggleClass('options-visible', this.model.active());
  }

  updateToolbar() {
    // Disable moving backbone.
    this.$('.js-shift-left, .js-shift-right').toggleClass('hidden', this.model.index() === 0);

    const disableShiftLeft = this.model.index() === 1;
    this.$('.js-shift-left').toggleClass('disabled', disableShiftLeft).attr({disabled: disableShiftLeft});
    const disableShiftRight = this.model.index() === this.model.collection.length - 1;
    this.$('.js-shift-right').toggleClass('disabled', disableShiftRight).attr({disabled: disableShiftRight});

    this.$('[data-toggle="tooltip"]').tooltip({container: 'body'});
  }

  render() {
    this.$('[data-toggle="tooltip"]').tooltip('destroy');
    const fragment = this.model.isEmpty() ? null : this.model.singleFragment();

    let info = {
      index: this.model.index(),
      active: this.model.active(),
      empty: this.model.isEmpty(),
      slotName: this.model.displayName(),
      spacer: this.model.spacer(),
    };

    if (!this.model.isEmpty()) {
      const seqLength = fragment.getSequence().length();
      // eslint-disable-next-line no-restricted-syntax
      info = _.extend(info, {
        name: fragment.sequenceMetadata().name,
        start: fragment.start(),
        end: fragment.end(),
        reverse: fragment.reverse(),
        seqLength,
        startIndex: fragment.getSequence().startIndex(),
        length: sequtil.length(fragment.start(), fragment.end(), seqLength),
        sequtil,
        util,
        enzymes: fragment.getEnzymes(),
      });
    }

    this.$el.html(this.template(info));
    this.toggleActive();
    this.updateToolbar();
    this.toggleDelete();
    return this;
  }
}
SimpleSlotView.initClass();

export default SimpleSlotView;
